export default __webpack_public_path__ + "static/media/screen5.578120fc.svg";